import { render } from "./BaseDashboardNavTopBar.vue?vue&type=template&id=5dc9b2f8"
import script from "./BaseDashboardNavTopBar.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseDashboardNavTopBar.vue?vue&type=script&setup=true&lang=js"

import "./BaseDashboardNavTopBar.vue?vue&type=style&index=0&id=5dc9b2f8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/helpers/BaseDashboardNavTopBar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5dc9b2f8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5dc9b2f8', __exports__)) {
    api.reload('5dc9b2f8', __exports__)
  }
  
  module.hot.accept("./BaseDashboardNavTopBar.vue?vue&type=template&id=5dc9b2f8", () => {
    api.rerender('5dc9b2f8', render)
  })

}


export default __exports__